import ProductIndex from './ProductIndex';
import ProductCreate from './ProductCreate';
import ProductSettings from './ProductSettings';
import ProductSingle from './ProductSingle';

export default function (app) {

    const settings = ProductSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    ProductIndex(app, settings);

    ProductCreate(app, settings);

    ProductSingle(app, settings);

}